import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            "AIzaSyC6i2P2MMPxvLPMzPlF58zO4oKHOursZFE",
  authDomain:        "fadeflow-3ccc9.firebaseapp.com",
  projectId:         "fadeflow-3ccc9",
  storageBucket:     "fadeflow-3ccc9.firebasestorage.app",
  messagingSenderId: "504771706235",
  appId:             "1:504771706235:web:60f7d7754bde0bada151de",
};

const app = initializeApp(firebaseConfig);
export const db   = getFirestore(app);
export const auth = getAuth(app);
